import React, {useCallback, useEffect} from 'react'
import {useTranslation} from '@modifi/plugin-i18n'
import {Col, DangerAlert, H6, Row, SuccessAlert, ButtonLink, PreviousIcon} from '@modifi/ui'
import {CustomerUploadManager} from '@modifi/plugin-documents'
import {Form} from '@modifi/plugin-forms'
import {IntermediaryShareholderFormData} from '../constants'
import {ConnectedFormFooter} from '../../../../plugins/onboarding/components/form-cta-footer'

import IntermediaryShareHoldersFormContent from '../components/intermediary-shareholders-form-content'
import {ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS} from '../../../../routes/constants'
import {EntityFormData} from '../../../../types/common'

export type CreateIntermediaryShareHoldersProps = {
  isLoading: boolean
  updatePending: boolean
  formData: EntityFormData<IntermediaryShareholderFormData>
  onSubmit: (changes: Record<string, unknown>) => void
  onDiscard: () => void
  hasError: boolean
  errorMessage?: string
  pageIsVerified: boolean
  redirect: (route: string) => void
}

const CreateIntermediaryShareHolders: React.FC<CreateIntermediaryShareHoldersProps> = ({
  updatePending,
  hasError,
  errorMessage,
  isLoading,
  onSubmit,
  formData,
  onDiscard,
  pageIsVerified,
  redirect,
}) => {
  const {t} = useTranslation(['charon', 'plugin-forms'])

  useEffect(() => {
    onDiscard()
  }, [onDiscard])

  const handleSubmit = useCallback(
    (changes: Record<string, any>) => {
      onSubmit(changes)
    },
    [onSubmit]
  )

  if (isLoading) {
    return null
  }
  return (
    <CustomerUploadManager>
      {pageIsVerified && (
        <SuccessAlert>{t('onboarding-section.fully-verified-alert')}</SuccessAlert>
      )}
      {hasError && errorMessage && <DangerAlert>{errorMessage}</DangerAlert>}

      <Row>
        <Col>
          <ButtonLink
            data-target="shareholder-summary-page"
            onClick={() => redirect(ROUTE_COMPANY_PROFILE_INTERMEDIARY_SHAREHOLDERS)}
          >
            <PreviousIcon /> {t('summary-page.back-button.label')}
          </ButtonLink>
        </Col>
      </Row>

      <Row>
        <Col mb={40}>
          <H6>{t('intermediary-shareholder-create-page.heading')}</H6>
        </Col>
      </Row>

      <Form
        isLoading={updatePending}
        defaultValues={formData.defaultValues}
        initialValues={formData.initialValues}
        onSubmit={handleSubmit}
        onDiscard={onDiscard}
      >
        <IntermediaryShareHoldersFormContent />

        <ConnectedFormFooter loading={updatePending} hasError={hasError} />
      </Form>
    </CustomerUploadManager>
  )
}

export default CreateIntermediaryShareHolders
